var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLevel2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 184,
    height: 183,
    viewBox: "0 0 184 183",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 184,
    height: 183
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.5795 30.0954L126.185 34.4073L82.4989 81.8267L66.5795 30.0954Z",
    fill: "#6C6C6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.185 34.4073L91.7315 0.156128L66.5795 30.0954L126.185 34.4073Z",
    fill: "#6C6C6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.185 34.4073L91.7315 0.156128L150.374 16.1971L126.185 34.4073Z",
    fill: "#6C6C6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.7315 0.156128L150.374 16.1971L113.485 1.47385L91.7315 0.156128Z",
    fill: "#6C6C6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.5795 30.0954L32.9338 21.7436L62.5205 5.70825L66.5795 30.0954Z",
    fill: "#6C6C6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.7315 0.156128L62.5205 5.70825L66.5795 30.0954L91.7315 0.156128Z",
    fill: "#6C6C6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.9338 21.7436L23.9517 70.2625L66.5795 30.0954L32.9338 21.7436Z",
    fill: "#6C6C6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.4989 81.8267L66.5795 30.0954L23.9517 70.2625L82.4989 81.8267Z",
    fill: "#6C6C6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.9338 21.7436L23.9517 70.2625L0.625732 68.9256L32.9338 21.7436Z",
    fill: "#6C6C6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.4989 81.8267L43.6228 132.295L23.9517 70.2625L82.4989 81.8267Z",
    fill: "#6C6C6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.625732 68.9256L23.9517 70.2625L6.22681 114.385L0.625732 68.9256Z",
    fill: "#6C6C6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.6228 132.295L6.22681 114.385L23.9517 70.2625L43.6228 132.295Z",
    fill: "#6C6C6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.625732 68.9256L6.22681 114.385L4.68661 120.589L0.625732 68.9256Z",
    fill: "#6C6C6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.374 16.1971L172.763 58.3086L126.185 34.4073L150.374 16.1971Z",
    fill: "#6C6C6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.4989 81.8267L148.043 98.4677L126.185 34.4073L82.4989 81.8267Z",
    fill: "#6C6C6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.374 16.1971L183.337 60.9334L172.763 58.3086L150.374 16.1971Z",
    fill: "#6C6C6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.185 34.4073L172.763 58.3086L148.043 98.4677L126.185 34.4073Z",
    fill: "#6C6C6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.4989 81.8267L101.92 138.138L148.043 98.4677L82.4989 81.8267Z",
    fill: "#6C6C6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.763 58.3086L148.043 98.4677L183.574 110.813L172.763 58.3086Z",
    fill: "#6C6C6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.337 60.9334L183.574 110.813L172.763 58.3086L183.337 60.9334Z",
    fill: "#6C6C6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.92 138.138L144.559 156.98L148.043 98.4677L101.92 138.138Z",
    fill: "#6C6C6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.574 110.813L148.043 98.4677L144.559 156.98L183.574 110.813Z",
    fill: "#6C6C6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.4989 81.8267L101.92 138.138L43.6228 132.295L82.4989 81.8267Z",
    fill: "#6C6C6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.574 110.813L165.038 153.342L144.559 156.98L183.574 110.813Z",
    fill: "#6C6C6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.22681 114.385L28.7743 159.597L4.68661 120.589L6.22681 114.385Z",
    fill: "#6C6C6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.6228 132.295L28.7743 159.597L6.22681 114.385L43.6228 132.295Z",
    fill: "#6C6C6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.92 138.138L43.6228 132.295L82.3942 176.061L101.92 138.138Z",
    fill: "#6C6C6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.7743 159.597L82.3942 176.061L43.6228 132.295L28.7743 159.597Z",
    fill: "#6C6C6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.559 156.98L101.92 138.138L82.3942 176.061L144.559 156.98Z",
    fill: "#6C6C6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.7743 159.597L68.5375 182.549L82.3942 176.061L28.7743 159.597Z",
    fill: "#6C6C6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.038 153.342L120.6 181.741L144.559 156.98L165.038 153.342Z",
    fill: "#6C6C6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.3942 176.061L68.5375 182.549L120.6 181.741L82.3942 176.061Z",
    fill: "#6C6C6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.559 156.98L82.3942 176.061L120.6 181.741L144.559 156.98Z",
    fill: "#6C6C6C"
  })))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66.5795 30.0954L126.185 34.4074L82.4989 81.8268L66.5795 30.0954Z",
    fill: "#C4C4C4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M126.185 34.4074L91.7315 0.156166L66.5796 30.0954L126.185 34.4074Z",
    fill: "#D3D3D3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M126.185 34.4074L91.7314 0.156189L150.373 16.1972L126.185 34.4074Z",
    fill: "#E4E4E4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M91.7315 0.156191L150.374 16.1972L113.485 1.47389L91.7315 0.156191Z",
    fill: "#E1E1E1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5794 30.0954L32.9338 21.7436L62.5204 5.70825L66.5794 30.0954Z",
    fill: "#B6B6B6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M91.7316 0.156193L62.5205 5.70832L66.5796 30.0954L91.7316 0.156193Z",
    fill: "#BFBFBF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9338 21.7437L23.9517 70.2626L66.5795 30.0954L32.9338 21.7437Z",
    fill: "#9F9F9F"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M82.4991 81.8268L66.5796 30.0954L23.9518 70.2626L82.4991 81.8268Z",
    fill: "#999999"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9338 21.7436L23.9517 70.2625L0.625671 68.9256L32.9338 21.7436Z",
    fill: "#999999"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M82.499 81.8267L43.6229 132.295L23.9518 70.2625L82.499 81.8267Z",
    fill: "#8C8C8C"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M0.625731 68.9256L23.9518 70.2625L6.22681 114.385L0.625731 68.9256Z",
    fill: "#8B8B8B"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M43.6229 132.295L6.22687 114.385L23.9518 70.2625L43.6229 132.295Z",
    fill: "#7A7A7A"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M0.625732 68.9257L6.22681 114.385L4.68661 120.589L0.625732 68.9257Z",
    fill: "#6E6E6E"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M150.374 16.1972L172.763 58.3086L126.185 34.4074L150.374 16.1972Z",
    fill: "#EEEEEE"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M82.4989 81.8267L148.043 98.4677L126.185 34.4074L82.4989 81.8267Z",
    fill: "#D1D1D1"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M150.374 16.1971L183.337 60.9335L172.763 58.3086L150.374 16.1971Z",
    fill: "#E9E9E9"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M126.185 34.4074L172.763 58.3086L148.043 98.4677L126.185 34.4074Z",
    fill: "#E0E0E0"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M82.499 81.8267L101.92 138.138L148.043 98.4677L82.499 81.8267Z",
    fill: "#B3B3B3"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M172.763 58.3086L148.043 98.4677L183.574 110.813L172.763 58.3086Z",
    fill: "#DEDEDE"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M183.337 60.9334L183.573 110.813L172.763 58.3086L183.337 60.9334Z",
    fill: "#E7E7E7"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M101.92 138.138L144.559 156.98L148.043 98.4677L101.92 138.138Z",
    fill: "#B9B9B9"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M183.574 110.813L148.043 98.4677L144.559 156.98L183.574 110.813Z",
    fill: "#D0D0D0"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M82.4991 81.8267L101.92 138.138L43.6229 132.296L82.4991 81.8267Z",
    fill: "#848484"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M183.573 110.813L165.038 153.342L144.559 156.98L183.573 110.813Z",
    fill: "#C9C9C9"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M6.22681 114.385L28.7744 159.597L4.68661 120.589L6.22681 114.385Z",
    fill: "#606060"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M43.6228 132.295L28.7744 159.597L6.22681 114.385L43.6228 132.295Z",
    fill: "#636363"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M101.92 138.138L43.6229 132.296L82.3943 176.061L101.92 138.138Z",
    fill: "#616161"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7743 159.597L82.3942 176.061L43.6228 132.296L28.7743 159.597Z",
    fill: "#595959"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M144.559 156.98L101.92 138.138L82.3943 176.061L144.559 156.98Z",
    fill: "#777777"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7744 159.597L68.5374 182.549L82.3942 176.061L28.7744 159.597Z",
    fill: "#2E2E2E"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M165.038 153.342L120.6 181.741L144.559 156.98L165.038 153.342Z",
    fill: "#9C9C9C"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M82.3943 176.061L68.5375 182.549L120.6 181.741L82.3943 176.061Z",
    fill: "#3D3D3D"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M144.559 156.98L82.3943 176.061L120.6 181.741L144.559 156.98Z",
    fill: "#6C6C6C"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color"
    },
    opacity: 0.8
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    width: 183,
    height: 183,
    fill: "#EB4076"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLevel2);
export default __webpack_public_path__ + "static/media/level2.c55bbed86e77692dcbc5a359be9c9cd6.svg";
export { ForwardRef as ReactComponent };